(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cdc-home-review-stars"]) return;
  try {
    
(() => {
  function placeHomeReviewStars() {
    const root = document.querySelector('[data-cdc-home-review-sources]');
    if (!root) return;

    const cards = [...document.querySelectorAll('.cdc-home .cdc-product-card')];
    root.querySelectorAll('[data-cdc-home-review-source]').forEach((source) => {
      const productUrl = source.dataset.productUrl || '';
      const target = cards.find((card) =>
        card.getAttribute('href') === productUrl && !card.querySelector('[data-cdc-card-review]')
      );
      const summary = source.querySelector('[data-cdc-card-review]');
      const title = target?.querySelector('h3');
      if (target && summary && title) title.insertAdjacentElement('afterend', summary);
    });

    root.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeHomeReviewStars, { once: true });
  } else {
    placeHomeReviewStars();
  }
  document.addEventListener('shopify:section:load', placeHomeReviewStars);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
